import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { PlaybackProvider } from "./PlaybackContext";
import process from "process";

// Assign process to window after all imports
window.process = process;

const container = document.getElementById("root");
const root = createRoot(container);

// Wrap App with Router, AuthProvider, and PlaybackProvider
root.render(
  <Router>
    <AuthProvider>
      <PlaybackProvider>
        <App />
      </PlaybackProvider>
    </AuthProvider>
  </Router>
);
